module.exports = __webpack_public_path__ + "media/assets/illustrations/welcome-image-36528e6addf21d0e1661a0189c25e220.png";